import * as Sentry from "@sentry/react-native";
import graphql from "babel-plugin-relay/macro";
import { useMemo } from "react";
import { useSubscription } from "react-relay";

const useTimeSlotListSubscription = ({
  agendaId,
  isCustomer,
}: {
  agendaId?: string;
  isCustomer?: boolean;
}) => {
  const config = useMemo(
    () => ({
      variables: {
        agendaId,
        isCustomer,
      },
      subscription: timeSlotListSubscriptionString,
      onError: (err: any) => {
        Sentry.captureException(err);
      },
    }),
    [agendaId, isCustomer]
  );
  useSubscription(config);
};

export default useTimeSlotListSubscription;

const timeSlotListSubscriptionString = graphql`
  subscription useTimeSlotListSubscription(
    $agendaId: ID!
    $isCustomer: Boolean!
  ) {
    timeSlotsChanged(agendaIds: [$agendaId]) {
      slots {
        ... on TimeSlot {
          id
          availability
          usedCapacity
          isLocked
          lockedUntil
          bookings {
            edges {
              node {
                id
                canUpdate
                writeAccess
                ownerClient {
                  __typename
                  ... on Member {
                    id
                  }
                  ... on Customer {
                    id
                  }
                }
                ... on StandardBooking {
                  status
                }
                ... on DiningBooking {
                  status
                }
                ... on LessonBooking {
                  status
                }
                rounds(noShowStatus: [PRESENT]) {
                  edges {
                    node {
                      __typename
                      courseLayout {
                        code
                      }
                      transportationType {
                        code
                        customCode
                        name
                      }
                      player {
                        id
                        firstName @skip(if: $isCustomer)
                        lastName @skip(if: $isCustomer)
                        __typename
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
